<section class="px-3 px-md-5 pt-3 pb-5">
    <h4 class="text-center heading1">Quotation Number : {{quotesInfo?.QuotationNumber}}</h4>
    <hr>
    <div class="d-flex justify-content-between mt-3">
        <div class="back-button mb-3">
            <span class="back-icon" (click)="goBack()"><i class="fa-solid fa-arrow-left"></i></span>
            <h4 class="back-button-heading mx-3">Proposal Form</h4>
        </div>
    </div>
    <div class="grid-shadow1 p-3">
        <mat-stepper [linear]="isLinear" #stepper [orientation]="(stepperOrientation | async)!" labelPosition="bottom">
            <ng-template  matStepperIcon="travelDetailsForm">
                <i class="fa fa-plane" aria-hidden="true"></i> 
              </ng-template>
            <ng-template  matStepperIcon="travelerInformationForm" *ngIf="!isBulkUpload">
                <i class="fa fa-user" aria-hidden="true"></i> 
              </ng-template>
            <ng-template  matStepperIcon="additionalInformationForm" *ngIf="!isBulkUpload">
                <i class="fa fa-info-circle" aria-hidden="true"></i> 
              </ng-template>
            <ng-template  matStepperIcon="beneficiaryDetailsForm" *ngIf="!isBulkUpload">
                <i class="fa fa-users" aria-hidden="true"></i> 
              </ng-template>

              <ng-template  matStepperIcon="uploadTemplateForm" *ngIf="isBulkUpload">
                <i class="fa-solid fa-upload" aria-hidden="true"></i>
              </ng-template>
            <ng-template  matStepperIcon="declarationForm">
                <i class="fa fa-file-signature" aria-hidden="true"></i> 
              </ng-template>


            <mat-step [stepControl]="travelDetailsForm" label="Travel Details" state="travelDetailsForm">
                <section class="py-3">
                    <form [formGroup]="travelDetailsForm">
                            <div class="row">
                                <div class="col-md-6 mb-2">
                                    <label class="field-label">Product Name <span class="text-red small">*</span></label>
                                    <mat-form-field class="w-100 mat-form-field-sm">
                                        <input matInput type="text" formControlName="productName">
                                    </mat-form-field>
                                    <div class="text-red small"
                                        *ngIf="travelDetailsForm.get('productName')?.invalid && (travelDetailsForm.get('productName')?.dirty || travelDetailsForm.get('productName')?.touched) && travelDetailsForm.get('productName')?.errors?.['required']">
                                        Product Name is required.
                                    </div>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <label class="field-label">Premium Amount <span class="text-red small">*</span></label>
                                    <mat-form-field class="w-100 mat-form-field-sm">
                                        <input matInput type="text" formControlName="premiumAmount">
                                    </mat-form-field>
                                    <div class="text-red small"
                                        *ngIf="travelDetailsForm.get('premiumAmount')?.invalid && (travelDetailsForm.get('premiumAmount')?.dirty || travelDetailsForm.get('premiumAmount')?.touched) && travelDetailsForm.get('premiumAmount')?.errors?.['required']">
                                        Premium Amount is required.
                                    </div>
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="field-label">Destination(s) <span class="text-red small">*</span></label>
                                <div class="">
                                    <mat-form-field class="example-chip-list w-100">
                                        <mat-chip-grid #chipGrid aria-label="Destination selection w-100"
                                            formControlName="destination">
                                            <mat-chip-row *ngFor="let destination of selectedDestinations"
                                                (removed)="remove(destination)">
                                                {{destination.ToCountryName}}
                                                <button matChipRemove
                                                    [attr.aria-label]="'remove ' + destination.ToCountryName">
                                                    <mat-icon>cancel</mat-icon>
                                                </button>
                                            </mat-chip-row>
                                        </mat-chip-grid>
                
                                        <input #destinationInput (focus)="onFocus()" [matChipInputFor]="chipGrid"
                                            [matAutocomplete]="auto" />
                                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                            <mat-option *ngFor="let destination of filteredDestinations | async"
                                                [value]="destination.TocountryID">
                                                {{destination.ToCountryName}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                    <div class="text-red small" *ngIf="(travelDetailsForm.get('destination')?.dirty || travelDetailsForm.get('destination')?.touched) && selectedDestinations.length==0">
                                        Destination is required.
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 mb-2">
                                    <label class="field-label">Trip Start Date <span class="text-red small">*</span></label>
                                    <mat-form-field class="w-100">
                                        <input matInput [matDatepicker]="tripStartDate" formControlName="tripStartDate"
                                            placeholder="DD/MM/YYYY">
                                        <mat-datepicker-toggle matIconSuffix [for]="tripStartDate"></mat-datepicker-toggle>
                                        <mat-datepicker #tripStartDate></mat-datepicker>
                                    </mat-form-field>
                                    <div class="text-red small"
                                        *ngIf="travelDetailsForm.get('tripStartDate')?.invalid && (travelDetailsForm.get('tripStartDate')?.dirty || travelDetailsForm.get('tripStartDate')?.touched) && travelDetailsForm.get('tripStartDate')?.errors?.['required']">
                                        Trip Start Date is required.
                                    </div>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <label class="field-label">Trip End Date <span class="text-red small">*</span></label>
                                    <mat-form-field class="w-100">
                                        <input matInput [matDatepicker]="tripEndDate" [min]="minTripEndDate"
                                            formControlName="tripEndDate" placeholder="DD/MM/YYYY">
                                        <mat-datepicker-toggle matIconSuffix [for]="tripEndDate"></mat-datepicker-toggle>
                                        <mat-datepicker #tripEndDate></mat-datepicker>
                                    </mat-form-field>
                                    <div class="text-red small"
                                        *ngIf="travelDetailsForm.get('tripEndDate')?.invalid && (travelDetailsForm.get('tripEndDate')?.dirty || travelDetailsForm.get('tripEndDate')?.touched) && travelDetailsForm.get('tripEndDate')?.errors?.['required']">
                                        Trip End Date is required.
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 mb-2">
                                    <label class="field-label">Traveling Days <span class="text-red small">*</span></label>
                                    <mat-form-field class="w-100 mat-form-field-sm">
                                        <input matInput type="text" (keypress)="numberOnly($event)"
                                            formControlName="travelingDays">
                                    </mat-form-field>
                                    <div class="text-red small"
                                        *ngIf="travelDetailsForm.get('travelingDays')?.invalid && (travelDetailsForm.get('travelingDays')?.dirty || travelDetailsForm.get('travelingDays')?.touched) && travelDetailsForm.get('travelingDays')?.errors?.['required']">
                                        Traveling Days is required.
                                    </div>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <label class="field-label">Number of Travelers <span
                                            class="text-red small">*</span></label>
                                    <mat-form-field class="w-100 mat-form-field-sm">
                                        <input matInput type="text" formControlName="numberOfTravelers"
                                            (keypress)="numberOnly($event)" (blur)="numberOfTravelers()">
                                    </mat-form-field>
                                    <div class="text-red small"
                                        *ngIf="travelDetailsForm.get('numberOfTravelers')?.invalid && (travelDetailsForm.get('numberOfTravelers')?.dirty || travelDetailsForm.get('numberOfTravelers')?.touched) && travelDetailsForm.get('numberOfTravelers')?.errors?.['required']">
                                        Number of Travelers is required.
                                    </div>
                                </div>
                            </div>
                            <div class="text-end mt-3">
                                <button class="primary-Button disabled-button" matStepperNext [disabled]="travelDetailsForm.invalid">Next</button>
                            </div>
                      </form>
                </section>
            </mat-step>
            <mat-step [stepControl]="travelerInformationForm" *ngIf="!isBulkUpload" label="Traveler Information" state="travelerInformationForm">
                <section class="py-3">
                    <form [formGroup]="travelerInformationForm">
                        <section class="mt-4" formArrayName="travelersDetails">
                            <div class="heading1 mb-4">Traveler Details</div>
                            <div *ngFor="let travelerDetail of getTravelersDetails.controls; let i = index"
                                [formGroupName]="i">
                                <div class="heading2">
                                    Traveler {{i + 1}}
                                    <section class="example-section d-inline">
                                        <mat-checkbox formControlName="isProposerATraveller"
                                            (change)="onProposerChange(travelerDetail, $event.checked)">Is the Proposer?
                                        </mat-checkbox>
                                    </section>
                                </div>
                                <div class="row">
                                    <!-- <div class="col-md-4 mb-2">
                                    <label class="field-label">Title </label>
                                    <mat-form-field>
                                        <mat-select formControlName="title">
                                            <mat-option value="option1">Mr</mat-option>
                                            <mat-option value="option2">Mrs</mat-option>
                                            <mat-option value="option3">others</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div> -->
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">First Name <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="firstName">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('firstName')?.invalid  && (getTravelersDetails.at(i).get('firstName')?.dirty || getTravelersDetails.at(i).get('firstName')?.touched) && getTravelersDetails.at(i).get('firstName')?.errors?.['required']">
                                            First Name is required.
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Last Name <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="lastName">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('lastName')?.invalid && (getTravelersDetails.at(i).get('lastName')?.dirty || getTravelersDetails.at(i).get('lastName')?.touched)  && getTravelersDetails.at(i).get('lastName')?.errors?.['required']">
                                            Last Name is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Name as per the passport <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="nameAsPerThePassport">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('nameAsPerThePassport')?.invalid  && (getTravelersDetails.at(i).get('nameAsPerThePassport')?.dirty || getTravelersDetails.at(i).get('nameAsPerThePassport')?.touched)  && getTravelersDetails.at(i).get('nameAsPerThePassport')?.errors?.['required']">
                                            Name as per the passport is required.
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Email ID <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="email" formControlName="emailId">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('emailId')?.invalid  && (getTravelersDetails.at(i).get('emailId')?.dirty || getTravelersDetails.at(i).get('emailId')?.touched) && getTravelersDetails.at(i).get('emailId')?.errors?.['required']">
                                            Email ID is required.
                                        </div>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('emailId')?.invalid  && (getTravelersDetails.at(i).get('emailId')?.dirty || getTravelersDetails.at(i).get('emailId')?.touched)  && getTravelersDetails.at(i).get('emailId')?.errors?.['email']">
                                            Enter valid email.
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Date of Birth <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100">
                                            <input matInput [matDatepicker]="picker" [max]="dateOfBirthMaxDate"
                                                formControlName="dateOfBirth" placeholder="DD/MM/YYYY"
                                                (dateChange)="dateOfBirthChange($event,i)">
                                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker="matDatepicker"></mat-datepicker>
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('dateOfBirth')?.invalid  && (getTravelersDetails.at(i).get('dateOfBirth')?.dirty || getTravelersDetails.at(i).get('dateOfBirth')?.touched)  && getTravelersDetails.at(i).get('dateOfBirth')?.errors?.['required']">
                                            Date of Birth is required.
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Age</label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput (keypress)="numberOnly($event)" type="text"
                                                formControlName="age">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('age')?.invalid  && (getTravelersDetails.at(i).get('age')?.dirty || getTravelersDetails.at(i).get('age')?.touched)  && getTravelersDetails.at(i).get('age')?.errors?.['required']">
                                            Age is required.
                                        </div>
                                    </div>
    
                                </div>
                                <div class="row">
                                    <div class="col-md-4 mb-2">
                                        <label class="field-label">Country Code <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100">
                                            <mat-select formControlName="mobileCode">
                                                <mat-option *ngFor="let code of countryCodes"
                                                    [value]="code.masterDataID">
                                                    <span> {{code.mdTitle}}</span>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('mobileCode')?.invalid  && (getTravelersDetails.at(i).get('mobileCode')?.dirty || getTravelersDetails.at(i).get('mobileCode')?.touched)  && getTravelersDetails.at(i).get('mobileCode')?.errors?.['required']">
                                            Country Code is required.
                                        </div>
                                    </div>
                                    <div class="col-md-8 mb-2">
                                        <label class="field-label">Mobile Number <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput (keypress)="numberOnly($event)" type="text"
                                                formControlName="mobileNumber">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('mobileNumber')?.invalid  && (getTravelersDetails.at(i).get('mobileNumber')?.dirty || getTravelersDetails.at(i).get('mobileNumber')?.touched)  && getTravelersDetails.at(i).get('mobileNumber')?.errors?.['required']">
                                            Mobile Number is required.
                                        </div>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('mobileNumber')?.invalid  && (getTravelersDetails.at(i).get('mobileNumber')?.dirty || getTravelersDetails.at(i).get('mobileNumber')?.touched)  && getTravelersDetails.at(i).get('mobileNumber')?.errors?.['minlength']">
                                            Mobile number should be at least 9 digits long.
                                        </div>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('mobileNumber')?.invalid  && (getTravelersDetails.at(i).get('mobileNumber')?.dirty || getTravelersDetails.at(i).get('mobileNumber')?.touched)  && getTravelersDetails.at(i).get('mobileNumber')?.errors?.['maxlength']">
                                            Mobile number should not exceed 9 digits.
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Passport Number <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="passportNumber">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('passportNumber')?.invalid  && (getTravelersDetails.at(i).get('passportNumber')?.dirty || getTravelersDetails.at(i).get('passportNumber')?.touched)  && getTravelersDetails.at(i).get('passportNumber')?.errors?.['required']">
                                            Passport Number is required.
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Relationship with the proposer <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100">
                                            <mat-select formControlName="relationshipWithTheProposer">
                                                <ng-container *ngFor="let relationship of relationshipList">
                                                    <mat-option
                                                        *ngIf="(travelerDetail.get('isProposerATraveller')?.value && relationship.masterDataID=='eaf41d97-4dd2-4406-b351-5424e55507b2') || relationship.masterDataID!='eaf41d97-4dd2-4406-b351-5424e55507b2'"
                                                        [value]="relationship.masterDataID">
                                                        {{relationship.mdTitle}}
                                                    </mat-option>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>
    
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('relationshipWithTheProposer')?.invalid && (getTravelersDetails.at(i).get('relationshipWithTheProposer')?.dirty || getTravelersDetails.at(i).get('relationshipWithTheProposer')?.touched)  && getTravelersDetails.at(i).get('relationshipWithTheProposer')?.errors?.['required']">
                                            Relationship with the proposer is required.
                                        </div>
                                    </div>
    
                                </div>
    
                                <div class="mb-2">
                                    <div class="mb-3">
                                        <label for="formFile" class="field-label">Upload Passport</label>
                                        <input class="form-control" type="file" accept="image/*"
                                            (change)="onFileSelected($event,i)" id="formFile"
                                            formControlName="passportFile">
                                    </div>
                                    <div class="mb-2"
                                    *ngIf="travelerDetail.get('passportFileAttachmentID')?.value!='00000000-0000-0000-0000-000000000000' && travelerDetail.get('passportFileAttachmentID')?.value">
                                    <div ><a class="link" (click)="DownloadPassportCopy(i)">Download Passport <i
                                                class="fa-solid fa-download"></i></a> </div>
                                </div>
                                </div>
                            </div>
                        </section>
                        <div *ngIf="getTravelersDetails.controls.length>0  && (getTravelersDetails.dirty || getTravelersDetails.touched) && getTravelersDetails.hasError('minAgeRequired')">
                            <span class="text-red small">At least one traveler must be 3 years old.</span>
                        </div>
                        <div class="text-end mt-3">
                            <button class="secondary-button--hover-border me-2" matStepperPrevious>Back</button>
                            <button class="primary-Button disabled-button" matStepperNext  [disabled]="travelerInformationForm.invalid">Next</button>
                          </div>
                    </form>
                </section>
            
            </mat-step>
            <mat-step [stepControl]="additionalInformationForm" *ngIf="!isBulkUpload" label="Additional Information" state="additionalInformationForm">
                <section class="py-3">
                    <form [formGroup]="additionalInformationForm">
                        <div class="mb-2">
                            <label class="field-label">KRA Pin Type<span class="text-red small">*</span></label>
                            <div>
                              <mat-radio-group formControlName="kraPinType">
                                <mat-radio-button *ngFor="let kRAPintype of kRAPintypeList" [value]="kRAPintype.masterDataID">
                                  {{ kRAPintype.mdTitle }}
                                </mat-radio-button>
                              </mat-radio-group>
                            </div>
                            <div class="text-red small"
                            *ngIf="additionalInformationForm.get('kraPinType')?.invalid && (additionalInformationForm.get('kraPinType')?.dirty || additionalInformationForm.get('kraPinType')?.touched) && additionalInformationForm.get('kraPinType')?.errors?.['required']">
                            KRA Pin Type is required.
                        </div>
                          </div>
    
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <label class="field-label">KRA Pin Number <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" 
                                        formControlName="kraPinNumber">
                                </mat-form-field>
                                <div class="form-text">
                                    Ex:A123456789X
                                  </div>
                                <div class="text-red small"
                                    *ngIf="additionalInformationForm.get('kraPinNumber')?.invalid && (additionalInformationForm.get('kraPinNumber')?.dirty || additionalInformationForm.get('kraPinNumber')?.touched) && additionalInformationForm.get('kraPinNumber')?.errors?.['required']">
                                    KRA Pin Number is required.
                                </div>
                                <div class="text-red small"
                                    *ngIf="additionalInformationForm.get('kraPinNumber')?.invalid && (additionalInformationForm.get('kraPinNumber')?.dirty || additionalInformationForm.get('kraPinNumber')?.touched) && additionalInformationForm.get('kraPinNumber')?.errors?.['invalidKraPinNumber']">
                                    KRA Pin Number is invalid.
                                </div>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="field-label">Insured's Occupation <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" 
                                        formControlName="insuredOccupation">
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="additionalInformationForm.get('insuredOccupation')?.invalid  && (additionalInformationForm.get('insuredOccupation')?.dirty || additionalInformationForm.get('insuredOccupation')?.touched) && additionalInformationForm.get('insuredOccupation')?.errors?.['required']">
                                    Insured's Occupation is required.
                                </div>
                            </div>
                        </div>
    
                        <section formGroupName="address">
                            <div class="heading2 mt-4 mb-2">Postal Address</div>
                            <div class="mb-2">
                                <label class="field-label">House Number <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" formControlName="houseNumber">
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="additionalInformationForm.get('address.houseNumber')?.invalid  && (additionalInformationForm.get('address.houseNumber')?.dirty || additionalInformationForm.get('address.houseNumber')?.touched) && additionalInformationForm.get('address.houseNumber')?.errors?.['required']">
                                    House Number is required.
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="field-label">Road Name <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" formControlName="roadName">
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="additionalInformationForm.get('address.roadName')?.invalid  && (additionalInformationForm.get('address.roadName')?.dirty || additionalInformationForm.get('address.roadName')?.touched) && additionalInformationForm.get('address.roadName')?.errors?.['required']">
                                    Road Name is required.
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="field-label">Pincode <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" formControlName="pincode"
                                        (keypress)="numberOnly($event)">
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="additionalInformationForm.get('address.pincode')?.invalid  && (additionalInformationForm.get('address.pincode')?.dirty || additionalInformationForm.get('address.pincode')?.touched) && additionalInformationForm.get('address.pincode')?.errors?.['required']">
                                    Pincode is required.
                                </div>
                            </div>
                        </section>
    
                        <div class="text-end mt-3">
                            <button class="secondary-button--hover-border me-2" matStepperPrevious>Back</button>
                            <button class="primary-Button disabled-button" matStepperNext  [disabled]="additionalInformationForm.invalid">Next</button>
                          </div>
                    </form>
                </section>
              
            </mat-step>
            <mat-step [stepControl]="beneficiaryDetailsForm" *ngIf="!isBulkUpload" label="Beneficiary Details" state="beneficiaryDetailsForm">
                <section class="py-3">
                    <form [formGroup]="beneficiaryDetailsForm">
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <label class="field-label">Beneficiary Name<span
                                    class="text-red small">*</span></label>
                            <mat-form-field class="w-100 mat-form-field-sm">
                                <input matInput type="text" formControlName="beneficiaryName">
                            </mat-form-field>
                            <div class="text-red small"
                            *ngIf="beneficiaryDetailsForm.get('beneficiaryName')?.invalid  && (beneficiaryDetailsForm.get('beneficiaryName')?.dirty || beneficiaryDetailsForm.get('beneficiaryName')?.touched) && beneficiaryDetailsForm.get('beneficiaryName')?.errors?.['required']">
                            Beneficiary Name is required.
                        </div>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="field-label">Beneficiary Mobile Number <span
                                    class="text-red small">*</span></label>
                            <mat-form-field class="w-100 mat-form-field-sm">
                                <input matInput (keypress)="numberOnly($event)" type="text"
                                    formControlName="beneficiaryTelephoneNo">
                            </mat-form-field>
                            <div class="text-red small"
                            *ngIf="beneficiaryDetailsForm.get('beneficiaryTelephoneNo')?.invalid  && (beneficiaryDetailsForm.get('beneficiaryTelephoneNo')?.dirty || beneficiaryDetailsForm.get('beneficiaryTelephoneNo')?.touched) && beneficiaryDetailsForm.get('beneficiaryTelephoneNo')?.errors?.['required']">
                            Beneficiary Mobile Number is required.
                        </div>
                        <div class="text-red small"
                        *ngIf="beneficiaryDetailsForm.get('beneficiaryTelephoneNo')?.invalid  && (beneficiaryDetailsForm.get('beneficiaryTelephoneNo')?.dirty || beneficiaryDetailsForm.get('beneficiaryTelephoneNo')?.touched)  && beneficiaryDetailsForm.get('beneficiaryTelephoneNo')?.errors?.['minlength']">
                        Beneficiary Mobile Number should be at least 9 digits long.
                    </div>
                    <div class="text-red small"
                        *ngIf="beneficiaryDetailsForm.get('beneficiaryTelephoneNo')?.invalid  && (beneficiaryDetailsForm.get('beneficiaryTelephoneNo')?.dirty || beneficiaryDetailsForm.get('beneficiaryTelephoneNo')?.touched)  && beneficiaryDetailsForm.get('beneficiaryTelephoneNo')?.errors?.['maxlength']">
                        Beneficiary Mobile Number should not exceed 9 digits.
                    </div>
                            </div>
                        </div>
                        <div class="text-end mt-3">
                            <button class="secondary-button--hover-border me-2" matStepperPrevious>Back</button>
                            <button class="primary-Button disabled-button" matStepperNext  [disabled]="beneficiaryDetailsForm.invalid">Next</button>
                          </div>
                    </form>
                </section>
            </mat-step>
            <mat-step [stepControl]="uploadTemplateForm" *ngIf="isBulkUpload" label="Travelers Information" state="uploadTemplateForm">
                <section class="py-3">
                    <form [formGroup]="uploadTemplateForm">
                        <div class=" row justify-content-center mb-3">
                            <div class="row col-md-7">
                                <div class="col-md-12 mb-2">
                                    <div class="card mb-3">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-10">
                                                    <div class="heading1 mb-3">Download Template</div>
                                                    <p class="text-secondary"> Click the download icon to access the template. After filling it out, upload it below.</p>
                                                </div>
                                                <div class="col-2 d-flex justify-content-center align-items-center">
                                                    <i class="fa-solid fa-download download-icon"  (click)="DownloadPolicyExcelTemplate()"></i>
                                                </div>
                                            </div>
                                         </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                <div class="upload-container">
                                  <div
                                    class="upload-box"
                                    (dragover)="onDragOver($event)"
                                    (dragleave)="onDragLeave($event)"
                                    (drop)="onDrop($event)"
                                  >
                                  <div class="row">
                                      <div class="col-9">
                                        <div class="upload-instructions">
                                          <span class="upload-icon"><i class="fa-solid fa-upload"></i></span> Drag and drop files here or upload <span class="text-red" *ngIf="numberOfApprovedUsers==0">*</span>
                                        </div>
                                        <small class="file-types">Accepted file types: xlsx, xls</small>
                                      </div>
                                      <div class="col-3 d-flex align-items-center justify-content-center">
                                        <input
                                        type="file"
                                        id="fileInput"
                                        class="file-input"
                                        (change)="onFileSelect($event)"
                                        accept=".xlsx, .xls"
                                      />
                                      <button class="upload-btn" (click)="triggerFileInput()">Upload</button>
                                      </div>
                                  </div>
                                  
                                  </div>
                                </div>
                                <div *ngIf="selectedTemplateFile" class="uploaded-file">Uploaded File: {{selectedTemplateFile?.name}}</div>
                                <div 
                                class="text-secondary small" 
                                *ngIf="userProposalBulkList.length==0" 
                                aria-live="polite"
                              >
                                <em>Note:</em> To proceed to the next step, please upload a template with detailes.
                              </div>
                                <div 
                                class="text-red small" 
                                *ngIf="numberOfApprovedUsers==0 && userProposalBulkList.length>0" 
                                aria-live="polite"
                              >The users are not approved. Please resolve the issue and reupload.
                              </div>
                              
                                
                                </div>
                            </div>
                        </div>
                        
                        <section class="table-responsive" *ngIf="userProposalBulkList.length>0">
                            <table class="table table-bordered">
                                <thead>
                                  <tr>
                                    <th scope="col">First Name</th>
                                    <th scope="col">Last Name</th>
                                    <th scope="col">Name as per the passport</th>
                                    <th scope="col">Email ID</th>
                                    <th scope="col">Date of Birth</th>
                                    <th scope="col">Age</th>
                                    <th scope="col">Relationship with the proposer</th>
                                    <th scope="col">Is the Proposer?</th>
                                    <th scope="col">Mobile Number</th>
                                    <th scope="col">Passport Number</th>
                                    <th scope="col">KRA Pin Type</th>
                                    <th scope="col">KRA Pin Number</th>
                                    <th scope="col">Insured's Occupation</th>
                                    <th scope="col">House Number</th>
                                    <th scope="col">Road Name</th>
                                    <th scope="col">Pincode</th>
                                    <th scope="col">Beneficiary Name</th>
                                    <th scope="col">Beneficiary Mobile Number </th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Message</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <ng-container *ngFor="let userProposal of userProposalBulkList; let i = index">
                                    <tr>
                                      <td scope="row">{{userProposal.fIRSTNAME}}</td>
                                      <td scope="row">{{userProposal.lASTNAME}}</td>
                                      <td scope="row">{{userProposal.fULLNAME}}</td>
                                      <td scope="row">{{userProposal.eMAILID}}</td>
                                      <td scope="row">{{userProposal.dATEOFBIRTH | date: 'dd/MM/yyyy' }}</td>
                                      <td scope="row">{{userProposal.aGE}}</td>
                                      <td scope="row">{{userProposal.rELATIONSHIPWITHTHEPROPOSER}}</td>
                                      <td scope="row">{{userProposal.iSTHEPROPOSER}}</td>
                                      <td scope="row">{{userProposal.mOBILENO}}</td>
                                      <td scope="row">{{userProposal.pASSPORTNUMBER}}</td>
                                      <td scope="row">{{userProposal.kRAPINTYPE}}</td>
                                      <td scope="row">{{userProposal.kRAPINNUMBER}}</td>
                                      <td scope="row">{{userProposal.iNSUREDOCCUPATION}}</td>
                                      <td scope="row">{{userProposal.hOUSENUMBER}}</td>
                                      <td scope="row">{{userProposal.rOADNAME}}</td>
                                      <td scope="row">{{userProposal.pINCODE}}</td>
                                      <td scope="row">{{userProposal.bENEFICIARYNAME}}</td>
                                      <td scope="row">{{userProposal.bENEFICIARYMOBILENUMBER}}</td>
                                      <td scope="row">
                                        <div [ngClass]="{'text-success': !userProposal.iSERROR, 'text-danger': userProposal.iSERROR}">
                                          {{ userProposal.iSERROR ? 'Rejected' : 'Approved' }}
                                        </div>
                                      </td>
                                      
                                      <td scope="row">
                                        <div *ngFor="let errorMessage of userProposal.eRRORMESSAGE">
                                            {{errorMessage.Value}}
                                        </div>
                                      </td>
                                    </tr>
                                  </ng-container>
                                </tbody>
                              </table>
                        </section>
                        <div class="text-end mt-3">
                            <button class="secondary-button--hover-border me-2" matStepperPrevious>Back</button>
                            <button class="primary-Button disabled-button" matStepperNext  [disabled]="numberOfApprovedUsers==0">Next</button>
                          </div>
                    </form>
                </section>
            </mat-step>


            <mat-step [stepControl]="declarationForm" label="Declaration" state="declarationForm">
                <section class="py-3">
                    <form [formGroup]="declarationForm">
                        <section class="destination-section mb-3" formArrayName="declarationInfo">
                            <div class="d-flex align-items-center primary-heading mb-2">
                                <mat-checkbox class="ml-2" [formControl]="allDeclarationsControl"  (change)="selectAllDeclarations($event.checked)">
                                    <span class="primary-heading">DECLARATION (I/We declare that) :</span>  
                                  </mat-checkbox>
                                
                              </div>
                            <div class="example-section mb-2" *ngFor="let declaration of declarationList; let i = index">
                              <mat-checkbox class="example-margin" [formControlName]="i" (change)="updateAllDeclarationsSelected()">
                                {{declaration.mdTitle}}
                              </mat-checkbox>
                            </div>
                          </section>
                        <section class="consent-section"  formArrayName="consentInfo">
                            <div class="d-flex align-items-center primary-heading mb-2">
                                
                                <mat-checkbox class="ml-2" [formControl]="allConsentsControl" (change)="selectAllConsents($event.checked)">
                                    <span class="primary-heading">CONSENT  (I/We Consent that):</span>
                                  </mat-checkbox>
                              </div>
                            <div class="example-section mb-2" *ngFor="let consent of consentList; let i = index">
                                <mat-checkbox class="example-margin" [formControlName]="i" (change)="updateAllConsentsSelected()">
                                  {{consent.mdTitle}}
                                </mat-checkbox>
                              </div>
                        </section>
                        <div class="text-end mt-3">
                            <button class="secondary-button--hover-border me-2" matStepperPrevious>Back</button>
                            <button class="primary-Button disabled-button" (click)="submit()"  [disabled]="declarationForm.invalid">Submit</button>
                        </div>
                    </form>
                </section>
            </mat-step>
        </mat-stepper>
    </div>
  </section>
  